import { ChannelStatsCache, LastWatchedEntry, tvpil } from './tvpil';

const LAST_WATCHED = 'lastWatchedByPageReference';
const CHANNEL_STATS = 'channelsStats';

async function getItem<T>(key: string, defaultValue: T): Promise<T> {
  try {
    const data = (await tvpil.cacheService.getItem(key)) as T;
    return data ?? defaultValue;
  } catch (e) {
    return defaultValue;
  }
}

async function setItem<T>(key: string, value: T, ttl: number) {
  try {
    tvpil.cacheService.setItem(key, value, ttl);
  } catch (e) {
    // log error
  }
}

async function removeItem(key: string) {
  try {
    tvpil.cacheService.removeItem(key);
  } catch (e) {
    // log error
  }
}

export const storage = {
  async getLastWatched() {
    return getItem<Record<string, LastWatchedEntry>>(LAST_WATCHED, {});
  },

  setLastWatched(data: Record<string, LastWatchedEntry>) {
    return setItem(LAST_WATCHED, data, Number.MAX_SAFE_INTEGER);
  },

  removeLastWatched() {
    return removeItem(LAST_WATCHED);
  },

  getWatchStats() {
    return getItem<ChannelStatsCache>(CHANNEL_STATS, {});
  },

  setWatchStats(data: ChannelStatsCache) {
    return setItem(CHANNEL_STATS, data, Number.MAX_SAFE_INTEGER);
  },
};
